import React from 'react';
import { FileText, Zap, Flame, Shield, Lock, CreditCard, Users, Star, MapPin, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative pt-10 pb-12 md:pt-20 md:pb-24 overflow-hidden" data-id="element-116">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-orange/5 rounded-full blur-[120px] pointer-events-none" data-id="element-117" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-118">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-119">
          {/* Title — centered, 2 lines */}
          <FadeIn data-id="element-120">
            <h1 className="text-4xl sm:text-5xl md:text-7xl leading-[0.95] mb-5 md:mb-6 text-glow" data-id="element-121">
              Todo tu año de Clases de{' '}
              <span className="text-brand-orange block md:inline" data-id="element-122">
                Calistenia Resuelto
              </span>
            </h1>
          </FadeIn>

          {/* Product Mockup — centered below title */}
          <FadeIn delay={0.1} className="w-full" data-id="element-123">
            <div className="relative max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-124">
              <div className="absolute inset-0 bg-gradient-to-tr from-brand-orange/20 via-brand-orange/5 to-transparent rounded-2xl blur-3xl" data-id="element-125" />
              <img src="https://cdn.magicpatterns.com/uploads/jKxFSFawYviPofZcqK7Uzx/Gemini_Generated_Image_9vcima9vcima9vci.png" alt="Calistenia Avanzada Resuelta Megapack" className="relative z-10 w-full h-auto rounded-2xl border border-brand-border shadow-2xl" data-id="element-126" />
              {/* Floating Badge */}
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 md:left-auto md:right-4 md:translate-x-0 bg-brand-card border border-brand-border px-3 py-2 md:px-4 md:py-3 rounded-xl shadow-xl z-20 flex items-center gap-2 md:gap-3 whitespace-nowrap" data-id="element-127">
                <div className="bg-brand-orange/20 p-1.5 md:p-2 rounded-lg" data-id="element-128">
                  <FileText className="w-4 h-4 md:w-6 md:h-6 text-brand-orange" data-id="element-129" />
                </div>
                <div className="text-left" data-id="element-130">
                  <p className="font-display text-lg md:text-2xl leading-none" data-id="element-131">
                    6+6
                  </p>
                  <p className="text-[9px] md:text-xs text-brand-muted uppercase tracking-wider" data-id="element-132">
                    Módulos + Bonos
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Subhead — below mockup */}
          <FadeIn delay={0.15} data-id="element-133">
            <p className="text-sm md:text-lg text-brand-muted mb-5 md:mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-134">
              Tu plan completo de calistenia en casa listo: progresiones,
              estáticos, dinámicos, fuerza estricta y planificación.{' '}
              <span className="text-brand-text font-medium" data-id="element-135">
                Sin estancarte.
              </span>
            </p>
          </FadeIn>

          {/* Compact badges row — directly above CTA */}
          <FadeIn delay={0.2} data-id="element-136">
            <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 mb-4 md:mb-5" data-id="element-137">
              <span className="inline-flex items-center gap-1 bg-brand-card border border-brand-border px-2 py-0.5 md:px-2.5 md:py-1 rounded-full text-[10px] md:text-xs font-medium text-brand-muted" data-id="element-138">
                <FileText className="w-3 h-3 text-brand-orange" data-id="element-139" /> PDF Digital
              </span>
              <span className="inline-flex items-center gap-1 bg-brand-card border border-brand-border px-2 py-0.5 md:px-2.5 md:py-1 rounded-full text-[10px] md:text-xs font-medium text-brand-muted" data-id="element-140">
                <Zap className="w-3 h-3 text-brand-orange" data-id="element-141" /> Acceso Inmediato
              </span>
              <span className="inline-flex items-center gap-1 bg-brand-orange/10 border border-brand-orange/30 px-2 py-0.5 md:px-2.5 md:py-1 rounded-full text-[10px] md:text-xs font-medium text-brand-orange" data-id="element-142">
                <Flame className="w-3 h-3" data-id="element-143" /> Intermedio - Avanzado
              </span>
            </div>
          </FadeIn>

          {/* CTA */}
          <FadeIn delay={0.25} data-id="element-144">
            <Button href="#pricing" size="lg" className="mb-6 md:mb-8 group w-full sm:w-auto" data-id="element-145">
              💥 QUIERO MI CALISTENIA RESUELTA AHORA
              <ArrowRight className="ml-2 w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-146" />
            </Button>
          </FadeIn>

          {/* Trust Strip — centered grid */}
          <FadeIn delay={0.3} className="w-full" data-id="element-147">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2 md:gap-4 text-xs md:text-sm text-brand-muted border-t border-brand-border pt-5 md:pt-6 max-w-2xl mx-auto justify-items-center sm:justify-items-start" data-id="element-148">
              <div className="flex items-center gap-1.5" data-id="element-149">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-150" />{' '}
                Garantía 7 días
              </div>
              <div className="flex items-center gap-1.5" data-id="element-151">
                <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-152" />{' '}
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-153">
                <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-154" />{' '}
                Mercado Pago
              </div>
              <div className="flex items-center gap-1.5" data-id="element-155">
                <Users className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-156" />{' '}
                +500 Atletas
              </div>
              <div className="flex items-center gap-1.5" data-id="element-157">
                <Star className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-158" />{' '}
                4.9 Rating
              </div>
              <div className="flex items-center gap-1.5" data-id="element-159">
                <MapPin className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-160" />{' '}
                Todo Argentina
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}